var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgObjectVanMinor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1.88013,
    width: 53,
    height: 53,
    rx: 6.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1.88013,
    width: 53,
    height: 53,
    rx: 6.5,
    stroke: "#0089EC",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.1333 17.1301H13.5V35.8801H15.3833C15.3833 36.8747 15.7784 37.8285 16.4817 38.5318C17.1849 39.235 18.1387 39.6301 19.1333 39.6301C20.1279 39.6301 21.0817 39.235 21.785 38.5318C22.4882 37.8285 22.8833 36.8747 22.8833 35.8801H34.1333C34.1333 36.8747 34.5284 37.8285 35.2316 38.5318C35.9349 39.235 36.8887 39.6301 37.8833 39.6301C38.8779 39.6301 39.8317 39.235 40.535 38.5318C41.2382 37.8285 41.6333 36.8747 41.6333 35.8801H43.5V28.3801L34.1333 17.1301ZM19.1333 37.7635C18.7601 37.7668 18.3944 37.6591 18.0825 37.4542C17.7706 37.2493 17.5266 36.9563 17.3815 36.6125C17.2364 36.2686 17.1967 35.8895 17.2675 35.523C17.3383 35.1566 17.5163 34.8195 17.779 34.5544C18.0417 34.2894 18.3773 34.1083 18.743 34.0343C19.1088 33.9603 19.4883 33.9966 19.8335 34.1386C20.1786 34.2807 20.4737 34.522 20.6814 34.8321C20.8891 35.1422 21 35.5069 21 35.8801C20.9957 36.3754 20.7982 36.8495 20.4495 37.2013C20.1008 37.5531 19.6285 37.7548 19.1333 37.7635V37.7635ZM37.8833 37.7635C37.5101 37.7668 37.1444 37.6591 36.8325 37.4542C36.5206 37.2493 36.2766 36.9563 36.1315 36.6125C35.9864 36.2686 35.9467 35.8895 36.0175 35.523C36.0883 35.1566 36.2663 34.8195 36.529 34.5544C36.7917 34.2894 37.1273 34.1083 37.493 34.0343C37.8588 33.9603 38.2383 33.9966 38.5835 34.1386C38.9286 34.2807 39.2237 34.522 39.4314 34.8321C39.6391 35.1422 39.75 35.5069 39.75 35.8801C39.7457 36.3754 39.5482 36.8495 39.1995 37.2013C38.8508 37.5531 38.3785 37.7548 37.8833 37.7635V37.7635ZM41.6333 34.0135H41.1C40.7781 33.4412 40.3098 32.9648 39.743 32.6333C39.1763 32.3018 38.5315 32.1271 37.875 32.1271C37.2184 32.1271 36.5736 32.3018 36.0069 32.6333C35.4401 32.9648 34.9718 33.4412 34.65 34.0135H22.35C22.0281 33.4412 21.5598 32.9648 20.993 32.6333C20.4263 32.3018 19.7815 32.1271 19.125 32.1271C18.4684 32.1271 17.8236 32.3018 17.2569 32.6333C16.6901 32.9648 16.2218 33.4412 15.9 34.0135H15.3833V19.0135H33.25L41.5833 29.0135L41.6333 34.0135Z",
    fill: "#0089EC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjectVanMinor);
export default __webpack_public_path__ + "static/media/object-van-minor.762c54f32c0436ef1c1f4619491cd6fd.svg";
export { ForwardRef as ReactComponent };